<template>
    <div class="col-md-12 text-center" v-show="subscription == null">
        <div class="alert alert-warning">Você ainda não possui nenhuma assinatura disponível.</div>
        <router-link to="/assinatura/concluir" class="link-padrao">Clique aqui para assinar!</router-link>
    </div>
</template>

<script>
export default {
    name: 'MensagemAssinaturaNaoDisponivel',
    props: ['subscription']
}
</script>
